import React, { HTMLAttributes } from "react";
import classNames from "classnames";

import { BreadcrumbList } from "./Breadcrumb.styled";
import BreadcrumbItem from "./BreadcrumbItem";

export type BreadcrumbProps = HTMLAttributes<HTMLOListElement> & {};

const BreadcrumbComp = React.forwardRef<HTMLOListElement, BreadcrumbProps>((props, ref) => {
  const { className, ...restProps } = props;
  const breadcrumbClass = classNames("c-breadcrumb", className);

  return <BreadcrumbList data-testid="qa-breadcrumb-list" ref={ref} className={breadcrumbClass} {...restProps} />;
});

const Breadcrumb = Object.assign(BreadcrumbComp, {
  /**
   * Item of the Breadcrumb
   */
  Item: BreadcrumbItem
});

export default Breadcrumb;
